import {CSP, CSP_VALUES} from '../../../../constants'
import type {Preset} from '../../../../types'

export const MAPS_PRESET = {
  [CSP.SCRIPT]: [
    'https://api-maps.yandex.ru',
    'https://*.maps.yandex.net',
    'https://yandex.ru',
    'https://yastatic.net',
  ],
  [CSP.IMG]: [CSP_VALUES.DATA, 'https://*.maps.yandex.net', 'https://api-maps.yandex.ru', 'https://yandex.ru'],
  [CSP.CONNECT]: [
    'https://api-maps.yandex.ru',
    'https://core-renderer-tiles.maps.yandex.net/vmap2/',
    'https://*.maps.yandex.net',
    'https://yandex.ru',
    'https://*.taxi.yandex.net',
  ],
  [CSP.WORKER]: [CSP_VALUES.BLOB],
  [CSP.FRAME]: ['https://yandex.ru', 'https://api-maps.yandex.ru'],
  [CSP.CHILD]: ['https://api-maps.yandex.ru'],
  [CSP.STYLE]: [CSP_VALUES.BLOB],
} as const satisfies Preset
